import * as errorHandler from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import {
  SET_LIST_BANK,
  PROCESSING,
  SET_NON_MANDATORY_VA_PREFIX_BANK_LIST,
} from './types';
const { allBillerApiService, cdnApiService } = apiService.getInstance();

// Setter Payload Data
export const setListBank = data => ({
  type: SET_LIST_BANK,
  payload: data,
});

export const setNonMandatoryVaPrefixBankList = data => ({
  type: SET_NON_MANDATORY_VA_PREFIX_BANK_LIST,
  payload: data,
});

export const getListBank = params => async dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  // Do Load Data Bank List
  try {
    const response = await allBillerApiService.get('banks', { params });
    if (response.status === 200) {
      const { payload } = response.data;
      dispatch(banks.setListBank(payload));
    } else {
      errorHandler.errorHandle(response);
      dispatch(banks.setListBank([]));
    }
  } catch (error) {
    errorHandler.errorHandle(error);
    dispatch(banks.setListBank([]));
  }
};

export const getNonMandatoryVaPrefixBankList = () => async dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  // Do Load Data Payment Method
  try {
    const response = await cdnApiService.get(
      '/resource/json/lifestyle/test/all-biller-non-va-prefix-banks.json',
    );
    if (response.status === 200) {
      const { result } = response.data;
      dispatch(banks.setNonMandatoryVaPrefixBankList(result));
    } else {
      errorHandler.errorHandle(response);
      dispatch(banks.setNonMandatoryVaPrefixBankList([]));
    }
  } catch (error) {
    errorHandler.errorHandle(error);
    dispatch(banks.setNonMandatoryVaPrefixBankList([]));
  }
};

const banks = {
  setListBank,
  getListBank,
  setNonMandatoryVaPrefixBankList,
  getNonMandatoryVaPrefixBankList,
};

export default banks;
